import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthEffects } from './auth.effects';
import { authReducer } from './auth.reducer';
import { AUTH_STATE_SLICE } from './auth.state';

@NgModule({
  imports: [StoreModule.forFeature(AUTH_STATE_SLICE, authReducer), EffectsModule.forFeature([AuthEffects])],
})
export class AuthStoreModule {}
